<app-base-page-template>
  <app-base-page-content-template>
    <app-offerings-grid
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-offerings-grid>
  </app-base-page-content-template>
</app-base-page-template>
